import React, { useEffect } from "preact/compat";
import { data } from "./constants/data";
import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Main from "./components/Main/index";
import Question from "./components/Question/";
import Info from "./components/Info/";
import Connecting from "./components/Connecting/";
import ConnectingSecond from "./components/ConnectingSecond/";
import Loader from "./components/Loader/Loader";
import Analyze from "./components/Analyze/Analyze";
import Email from "./components/Email/";
import Cost from "./components/Cost/";
import Subscription from "./components/Subscription";
import Finish from "./components/Finish/Finish";
import Paywall from "./components/Subscription/Paywall/index";
import Offers30 from "./components/Offers/Offers30/Offers30";
import FinishEmail from "./components/Finish/FinishEmail/FinishEmail";
import { Text } from "./styled";
import { remoteFunction } from "./constants/remoteKeys";
import { useDispatch } from "react-redux";
import {
  FINISH_EMAIL_ROUTE,
  OFFER_30_ROUTE,
  OFFER_50_ROUTE,
  SLEEPS_PROBLEMS_ROUTE
} from "./constants/routes";
import Prepaywall from "./components/Prepaywall/Prepaywall";
import PreLand from "./components/PreLand/PreLand";

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    remoteFunction(dispatch);
  }, []);

  const setComponent = (type, data, route) => {
    switch (type) {
      case 1:
        return <Question data={data} type={type} currentRoute={route} />;
      case 2:
        return <Info data={data} type={type} route={route} />;
      case 3:
        return <Connecting data={data} />;
      case 4:
        return <Question data={data} type={type} currentRoute={route} />;
      case 5:
        return (
          <ConnectingSecond data={data} type={type} currentRoute={route} />
        );
      case 6:
        return (
          <ConnectingSecond data={data} type={type} currentRoute={route} />
        );
      case 7:
        return <Loader data={data} type={type} currentRoute={route} />;
      case 8:
        return <Question data={data} type={type} currentRoute={route} />;
      case 9:
        return <Analyze data={data} type={type} currentRoute={route} />;
      case 10:
        return <Email data={data} type={type} currentRoute={route} />;
      case 11:
        return <Cost data={data} type={type} currentRoute={route} />;
      case 12:
        return <Subscription data={data} type={type} currentRoute={route} />;
      case 13:
        return <Paywall type={type} currentRoute={route} />;
      case 14:
        return <Prepaywall type={type} currentRoute={route} />;
    }
  };

  return (
    <div className="App">
      <Router>
        <Switch>
          <Route exact path={"/"}>
            <Main />
          </Route>
          {data.map((item) => {
            return (
              <Route exact path={item.route}>
                {setComponent(item.type, item.data, item.route)}
              </Route>
            );
          })}
          <Route exact path={"/finish"}>
            <Finish />
          </Route>
          <Route exact path={OFFER_50_ROUTE}>
            <Offers30 emailPaywallType={1} />
          </Route>
          <Route exact path={OFFER_30_ROUTE}>
            <Offers30 emailPaywallType={2} />
          </Route>
          <Route exact path={FINISH_EMAIL_ROUTE}>
            <FinishEmail />
          </Route>
          <Route exact path={SLEEPS_PROBLEMS_ROUTE}>
            <PreLand />
          </Route>
        </Switch>
      </Router>
      {process.env.REACT_APP_FIREBASE_CONFIG !== "production" ? (
        <div style={{ position: "fixed", bottom: 2, left: 5 }}>
          <Text.Fifth>{`v.${process.env.REACT_APP_VERSION}`}</Text.Fifth>
        </div>
      ) : null}
    </div>
  );
}

export default App;
